import type { SVGProps } from 'react';

const SvgSubtitleOnFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20 4.25C20.9665 4.25 21.75 5.0335 21.75 6V18C21.75 18.9665 20.9665 19.75 20 19.75H4C3.0335 19.75 2.25 18.9665 2.25 18V6C2.25 5.0335 3.0335 4.25 4 4.25H20ZM17 14C16.4477 14 16 14.4477 16 15C16 15.5523 16.4477 16 17 16C17.5523 16 18 15.5523 18 15C18 14.4477 17.5523 14 17 14ZM7 14.25C6.58579 14.25 6.25 14.5858 6.25 15C6.25 15.4142 6.58579 15.75 7 15.75H14C14.4142 15.75 14.75 15.4142 14.75 15C14.75 14.5858 14.4142 14.25 14 14.25H7ZM7 10C6.44772 10 6 10.4477 6 11C6 11.5523 6.44772 12 7 12C7.55228 12 8 11.5523 8 11C8 10.4477 7.55228 10 7 10ZM10 10.25C9.58579 10.25 9.25 10.5858 9.25 11C9.25 11.4142 9.58579 11.75 10 11.75H17C17.4142 11.75 17.75 11.4142 17.75 11C17.75 10.5858 17.4142 10.25 17 10.25H10Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgSubtitleOnFilled;
